// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import YoutubeFilledSvg from "@fishx/icons-svg/es/asn/YoutubeFilled";
import FishxIcon from '../components/FishxIcon';

var YoutubeFilled = function YoutubeFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: YoutubeFilledSvg
  }));
};

YoutubeFilled.displayName = 'YoutubeFilled';
export default React.forwardRef(YoutubeFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/YoutubeFilled.js
// module id = 4415
// module chunks = 0